import { render, staticRenderFns } from "./NowPlaying.vue?vue&type=template&id=4a8e9a25&scoped=true&"
import script from "./NowPlaying.vue?vue&type=script&lang=js&"
export * from "./NowPlaying.vue?vue&type=script&lang=js&"
import style0 from "./NowPlaying.vue?vue&type=style&index=0&id=4a8e9a25&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8e9a25",
  null
  
)

export default component.exports